'use es6';

import FormattedMessage from 'I18n/components/FormattedMessage';
import PropTypes from 'prop-types';
import UIIllustration from 'UIComponents/image/UIIllustration';
import UILink from 'UIComponents/link/UILink';
import { NavMarker } from 'react-rhumb';
import ImagePage from '../ImagePage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ErrorPage = ({
  onClose
}) => /*#__PURE__*/_jsx(NavMarker, {
  name: "ERROR_PAGE",
  children: /*#__PURE__*/_jsxs(ImagePage, {
    image: /*#__PURE__*/_jsx(UIIllustration, {
      name: "errors/general"
    }),
    children: [/*#__PURE__*/_jsx("div", {
      className: "heading",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pages.error.heading"
      })
    }), /*#__PURE__*/_jsx(UILink, {
      onClick: onClose,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pages.error.close"
      })
    })]
  })
});
ErrorPage.propTypes = {
  onClose: PropTypes.func.isRequired
};
export default ErrorPage;